import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError,switchMap } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { projectConfig } from '../../../environments/environment';
import { AuthService } from '../auth.service';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {  const token = localStorage.getItem('accessToken');

  // Do not intercept the refresh-token call itself
  if (req.url.includes('/auth/refresh-token')) {
    return next(req);
  }

  // Skip token for S3 requests
  let authReq = req;
  if (token && !req.url.includes(`https://${projectConfig.bucketName}.s3.amazonaws.com`)) {
    authReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  const authService = inject(AuthService);
  const router = inject(Router);
  const dialog = inject(MatDialog);

  return next(authReq).pipe(
    catchError(err => {
      if (err.status === 401) {
        return authService.refreshToken().pipe(
          switchMap((res:any)=> {
            localStorage.setItem('accessToken', res.access_token);

            const retryReq = authReq.clone({
              setHeaders: { Authorization: `Bearer ${res.access_token}` }
            });

            return next(retryReq);
          }),
          catchError(error => {
            console.warn('[Interceptor] Token expired or unauthorized.', error);

            dialog.closeAll();
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
            localStorage.removeItem('user_id');
            localStorage.removeItem('user_name');
            localStorage.removeItem('originalTranslationData');

            router.navigate(['/login']);

            return throwError(() => error);
          })
        );
      }

      return throwError(() => err);
    })
  );
};
